<div class="panel panel-primary" data-testid="add-shift-modal-component">
    <div class="panel-heading">
      Add Shift to {{strike.Title}}
    </div>
    <div class="panel-body">
      <form class="form-horizontal" role="form" [formGroup]="addShiftForm">
        <div class="row">
          <div class="col-xs-6 col-sm-4">
            <label for="shiftName" class="control-label">Shift Name</label>
            <input
                class="form-control"
                name="shiftName"
                id="shiftName"
                data-testid="shift-name-input"
                type="text"
                formControlName="shiftName"
                validate-on="blur"
                required required-message="'Name is required'">
            <div *ngIf="shiftName?.invalid && (shiftName?.dirty || shiftName?.touched)">
              <div *ngIf="shiftName?.errors?.['required']">
                Name is required.
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-6 col-sm-6">
            <label for="startHour" class="control-label">Start Hour(Military format)</label>
            <input 
                data-testid="shift-start-hour-input"
                class="form-control"
                name="startHour"
                id="startHour"
                type="text"
                formControlName="startHour">
            <div *ngIf="startHour?.invalid && (startHour?.dirty || startHour?.touched)">
              <div *ngIf="startHour?.errors?.['minlength'] || startHour?.errors?.['maxlength']" data-testid="start-hour-error-message">
                Start hour must be four digits, military time. Ex: 1600
              </div>
              <div *ngIf="startHour?.errors?.['required']">
                Start Hour is required.
              </div>
            </div>
          </div>
          <div class="col-xs-6 col-sm-6">
            <label for="endHour" class="control-label">End Hour(Military format)</label>
            <input
                data-testid="shift-end-hour-input"
                class="form-control"
                name="endHour"
                id="endHour"
                type="text"
                formControlName="endHour">
            <div *ngIf="endHour?.invalid && (endHour?.dirty || endHour?.touched)">
              <div *ngIf="endHour?.errors?.['minlength'] || endHour?.errors?.['maxlength']">
                End hour must be four digits, military time. Ex: 1600
              </div>
              <div *ngIf="endHour?.errors?.['required']">
                End Hour is required.
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer clearfix">
          <div class="pull-right">
            <button type="button" class="btn btn-danger" (click)="closeModal()" data-testid="shift-modal-cancel-button">Cancel</button>
            <button type="button" class="btn btn-primary" (click)="addShift()" [disabled]="!addShiftForm.valid || disableButton" data-testid="add-shift-button">Add Shift</button>
          </div>
        </div>
      </form>
    </div>
  </div>
